import React, { useEffect, useState } from "react";
import { UserIcon, PrevIcon } from "../../../components/Icon";
import { Helmet } from "react-helmet";
import { BetaIcon } from "../../../assets/images";

type AppProps = {
  title: string;
  company_name?: string;
  client_code?: number | null;
  goBack?: boolean;
  style?: any;
};

const CommonHeader = ({
  title,
  goBack,
  style,
  company_name,
  client_code,
}: AppProps) => {
  const [companyName, setCompanyName] = useState<string>("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (company_name) {
      setCompanyName(company_name);
    }
  }, [company_name]);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {`${title} - FINAC by Akssai ProjExel` ?? `FINAC by Akssai ProjExel`}
        </title>
      </Helmet>
      <div
        style={style ? style : {}}
        className={`row ${windowWidth <= 430 ? "mt-2" : ""}`}
      >
        <div className="col-md-12">
          <h2>
            {true ? (
              <span
                className="pointer mr-2 back-button"
                onClick={() => window.history.back()}
              >
                <PrevIcon />
              </span>
            ) : null}
            {title}
            {title === "GST" ||
            title === "View E-Invoice" ||
            title === "View E-Way Bill" || 
            title === "Add OCR" ? (
              <img
                src={BetaIcon}
                alt="beta icon"
                className="ml-3"
                style={{ cursor: "pointer", width: "35px" }}
              />
            ) : (
              ""
            )}
          </h2>
          {client_code && (
            <div className="ml-4">
              <UserIcon /> &nbsp;
              {companyName} {"(" + client_code + ")"}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CommonHeader;
